<div class="tt-body">
    <app-fca-drop-down *ngIf="oemName==='stellantis'" [vehicleInfo]="vehicleModelInfo"></app-fca-drop-down>
    <app-iveco-drop-down *ngIf="oemName==='iveco'" [vehicleInfo]="vehicleModelInfo"></app-iveco-drop-down>
    <app-opel-drop-down *ngIf="oemName==='opel'" [vehicleInfo]="vehicleModelInfo"></app-opel-drop-down>
    <app-mgn-drop-down *ngIf="oemName==='mitsubishi'" [vehicleInfo]="vehicleModelInfo"></app-mgn-drop-down>
    <app-melco-drop-down *ngIf="oemName==='melco'" [vehicleInfo]="vehicleModelInfo"></app-melco-drop-down>
    <app-ssangyong-drop-down *ngIf="oemName==='ssangyong'" [vehicleInfo]="vehicleModelInfo"></app-ssangyong-drop-down>
    <app-stepper></app-stepper>
</div>